import { Button, Form, Input, message, Tag } from "antd";
import Typography from "app/shared/Typography";
import EmailUpdateForm from "./EmailUpdate";
import { useEffect, useState } from "react";
import { apiPost } from "app/services/apiServices";
import PhoneUpdateForm from "./PhoneUpdate";
import InvalidEmailForm from "./InvalidEmailUpdate";
export default function HotelDataUpdate({ type, contactDetails, onSuccess, segmentType, onDataRefresh, onRowDataUpdate }) {
  // const [hotelEmails, setHotelEmails] = useState([]);
  const [hotelNumbers, setHotelNumbers] = useState([]);
  const [hotelBookingId, setHotelBookingId] = useState("");
  const [hotelName, setHotelName] = useState("")
  const [isLoading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [client, setClient] = useState("");
  const [gstin, setGstin] = useState("")
  const [hotelAddress, setHotelAddress] = useState("")
  const [pincode, setPincode] = useState("")
  console.log(contactDetails, "contactDetails")
  const [invalidEmails, setInvalidEmails] = useState(contactDetails?.email_hotel_contact_invalid_email || []);

  const [hotelEmails, setHotelEmails] = useState(contactDetails?.email_hotel_contact_email || []);
  const [addedEmails, setAddedEmails] = useState([]);

  useEffect(() => {

    if (contactDetails) {
      setHotelBookingId(contactDetails?.email_bookingId || "");
      setHotelName(contactDetails?.email_hotel_name || contactDetails?.airline_name);
      setState(contactDetails?.email_hotel_state || "");
      setCity(contactDetails?.email_hotel_city || "");
      setClient(contactDetails?.booking_client_id || "");
      setGstin(contactDetails?.email_hotel_gstin || "");
      setHotelAddress(contactDetails?.email_hotel_address || "")
      setPincode(contactDetails.pincode || "")
      // setInvalidEmails(contactDetails?.email_hotel_contact_invalid_email || []);
      setInvalidEmails(
        Array.isArray(contactDetails?.email_hotel_contact_invalid_email)
          ? contactDetails.email_hotel_contact_invalid_email.map(email => email)
          : []
      );
      if (type === "email") {
        setHotelEmails(contactDetails?.email_hotel_contact_email || []);
      } else if (type === "phone") {
        setHotelNumbers(contactDetails?.email_hotel_contact_phone || []);
      }
    }
  }, [contactDetails, type]);
  const handleSubmitHotelInfo = async () => {
    setLoading(true);

    console.log("Inside handleSubmitHotelInfo")

    // if (!pincode) {
    //   messageApi.error({
    //     type: "error",
    //     content: "Pincode is required. Please provide a valid pincode.",
    //   });
    //   setLoading(false);
    //   return;
    // }

    // Prepare emails and phones
    const emails = (hotelEmails || []).filter(Boolean);
    const numbers = (hotelNumbers || []).filter(Boolean);

    // Determine vendor type
    console.log(segmentType, "segmentType")
    // const vendorType = segmentType === "AIRLINE" ? "Airline" : "Hotel";
    const vendorType = segmentType === "AIRLINE" ? "Airline" : "Hotel";

    // Build payload for vendor API

    console.log(addedEmails, "added emails check")
    console.log(addedEmails.length, "added emails length check")
    if (addedEmails.length > 0) {
      const vendorPayload = {
        gstin,
        city: city || hotelAddress,
        vendor_name_others_if_any: hotelName,
        email_list: emails.join(";"),
        primary_email_id: emails[0] || "",
        phone_numbers: numbers.join(";"),
        primary_phone_number: numbers[0] || "",
        source_added_via: "Manual",
        finkraft_vendor_type: vendorType,
        pincode,
        hotelName

      };

      // Call the vendor API
      try {
        const vendorResponse = await fetch("https://api-vendor-master.finkraftai.com/api/vendor/ingest/record/single", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(vendorPayload),
        });
        const vendorResult = await vendorResponse.json();
        // if (!vendorResult.status) {
        //   messageApi.error({
        //     type: "error",
        //     content: "Could not update vendor master",
        //   });
        //   setLoading(false);
        //   return;
        // }
      } catch (err) {
        messageApi.error({
          type: "error",
          content: "Vendor master API error",
        });
        setLoading(false);
        return;
      }
    }

    // Continue with your existing update logic
    const payload = {
      hotelName,
      state,
      client,
      city,
      gstin,
      pincode,
      hotelBookingId: hotelBookingId || "",
      ...(type === "email" && { hotel_emails: hotelEmails || [] }),
      ...(type === "phone" && { hotel_phone_numbers: hotelNumbers || [] }),
      invalidEmails,
      vendorType
    };
    const response = await apiPost(
      "https://stage-apiplatform.finkraftai.com/api/hotelFollowUp/detailsUpdate",
      // "http://localhost:7002/api/hotelFollowUp/detailsUpdate",
      payload
    );
    if (response.status) {
      messageApi.success({
        type: "success",
        content: "Hotel details updated",
      });
      if (type === "email") setHotelEmails([]);
      if (type === "phone") setHotelNumbers([]);
      
      // Update row data directly without refreshing grid
      if (onRowDataUpdate) {
        console.log('Updating row data directly...');
        onRowDataUpdate({
          ...contactDetails,
          email_hotel_contact_email: hotelEmails, // This is the key field that needs to be updated
          email_hotel_contact_phone: hotelNumbers,
          email_hotel_contact_invalid_email: invalidEmails
        });
      } else if (onDataRefresh) {
        console.log('Triggering grid refresh...');
        onDataRefresh();
      }
      
      onSuccess();
    } else {
      messageApi.error({
        type: "error",
        content: "Could not update hotel detail",
      });
    }
    setLoading(false);
  };

  console.log(invalidEmails, "invalidEmails")

  return (
    <div className="HotelUpdateForm" >
      <Form name="basic" autoComplete="off">
        {/* Conditionally render Email or Phone input based on `type` */}
        {type === "email" && (
          <div style={{ marginBottom: 24 }}>
            <Typography variant="xs" style={{ marginBottom: 6 }}>
              Emails
            </Typography>
            <EmailUpdateForm
              type="email"
              emailData={hotelEmails}
              // onChange={(data) => setHotelEmails(data)}
              onChange={(data) => {
                // Detect newly added emails
                const newEmails = data.filter(email => !hotelEmails.includes(email));
                if (newEmails.length > 0) {
                  setAddedEmails(prev => [...prev, ...newEmails]);
                }

                // Update the main hotelEmails array
                setHotelEmails(data);
              }}
            />
            <div style={{ marginTop: 20 }}>
              <Typography variant="xs" style={{ marginBottom: 6, color: "red" }}>
                Invalid Emails
              </Typography>
              <InvalidEmailForm
                type="email"
                emailData={contactDetails?.email_hotel_contact_invalid_email}
                onChange={(data) => setInvalidEmails(data)}
                hotelName={hotelName}
                invalidEmails={invalidEmails}

              />
            </div>
          </div>

        )}
        {type === "phone" && (
          <div style={{ marginTop: 24, marginBottom: 24 }}>
            <Typography variant="xs" style={{ marginBottom: 6 }}>
              Contact Numbers
            </Typography>
            <PhoneUpdateForm
              type="phone"
              phoneData={hotelNumbers}
              onChange={(data) => setHotelNumbers(data)}
            />
          </div>
        )}
        <Form.Item style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button type="primary" onClick={handleSubmitHotelInfo} loading={isLoading}>
            Submit
          </Button>
        </Form.Item>
      </Form>
      {contextHolder}
    </div>
  );
}










